var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    wrapperPadding: spacing.small,
    questionPaddingTopBottom: spacing.xSmall,
    questionPaddingLeftRight: spacing.small,
    pointsFontSize: typography.fontSizeSmall,
    pointsColor: colors.ash,
    contentWrapperMargin: spacing.medium,
    spacerHeight: '0.5rem',
    spacerWidth: '0.5rem'
  };
};
export default generateComponentTheme;